var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dashboard"},[_c(_setup.TopBar),_c('main',{staticClass:"main main--dark main--dashboard"},[_c(_setup.Content),_c(_setup.Aside)],1),_c(_setup.EditTaskModal,{ref:"editTaskModal"}),_c(_setup.Helper,{attrs:{"page":"homepage"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }